import React from 'react';

import { useFormContext } from 'react-hook-form';

import InputControl from '@/components/form/input-control';
import { Button } from '@/components/ui/button';
import { env } from '@/lib/env';
import type { LoginSchema } from '@/types/form/auth/login';

export default function FormLogin() {
	const { watch } = useFormContext<LoginSchema>();

	const [email] = watch(['email']);

	return (
		<div className="grid w-full grid-cols-1 gap-x-4 gap-y-2 md:grid-cols-2">
			<p className="col-span-full text-xl font-medium">Data Login</p>
			<InputControl name="name" label="Nama Perusahaan" isDisabled />
			<InputControl name="email" label="Email Perusahaan" isDisabled />
			<p className="border-t-accent-foreground/10 col-span-full mt-3 border-t pt-3 text-xl font-medium">
				Kata Sandi
			</p>
			<div className="col-span-full">
				<Button
					variant={'outline'}
					onClick={() => {
						const query = new URLSearchParams({
							returnurl: env.VITE_DUENDE_REDIRECT_URI,
							email,
							clientid: env.VITE_DUENDE_CLIENT_ID
						});

						const url = `${env.VITE_DUENDE_URL}/Account/ChangePassword?${query.toString()}`;

						globalThis.location.assign(url);
					}}
				>
					Ubah Kata Sandi
				</Button>
			</div>
		</div>
	);
}
